var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgIModelLoader(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 740 854.43' }, props),
        React.createElement("style", null, '\n    @keyframes iui-blink {\n      0% {\n        opacity: 0.3;\n      }\n\n      33% {\n        opacity: 1;\n      }\n\n      100% {\n        opacity: 0.3;\n      }\n    }\n  '),
        React.createElement("g", null,
            React.createElement("polygon", { id: 'outer3', style: {
                    animation: 'iui-blink 1s -0.17s infinite',
                }, fill: '#62bb47', points: '369.99 0 369.99 213.61 277.49 160.21 185 106.81 369.94 0.03 369.99 0' }),
            React.createElement("polygon", { id: 'outer2', style: {
                    animation: 'iui-blink 1s -0.11s infinite',
                }, fill: '#62bb47', points: '370 0 370 213.61 462.5 160.21 554.99 106.81 370.05 0.03 370 0' }),
            React.createElement("polygon", { id: 'outer5', style: {
                    animation: 'iui-blink 1s -0.28s infinite',
                }, fill: '#62bb47', points: '185 106.81 185 320.42 92.5 267.02 0.01 213.62 184.95 106.84 185 106.81' }),
            React.createElement("polygon", { id: 'outer4', style: {
                    animation: 'iui-blink 1s -0.22s infinite',
                }, fill: '#62bb47', points: '185 106.81 185 320.42 277.5 267.02 369.99 213.62 185.05 106.84 185 106.81' }),
            React.createElement("polygon", { id: 'outer6', style: {
                    animation: 'iui-blink 1s -0.33s infinite',
                }, fill: '#62bb47', points: '0 213.62 0 427.23 92.5 373.83 184.99 320.43 0.05 213.65 0 213.62' }),
            React.createElement("polygon", { id: 'outer8', style: {
                    animation: 'iui-blink 1s -0.44s infinite',
                }, fill: '#62bb47', points: '0 427.21 0 640.83 92.5 587.42 184.99 534.02 0.05 427.25 0 427.21' }),
            React.createElement("polygon", { id: 'inner1', style: {
                    animation: 'iui-blink 1s -0.16s infinite',
                }, fill: '#62bb47', points: '370 213.62 370 427.23 277.5 373.83 185.01 320.43 369.95 213.65 370 213.62' }),
            React.createElement("polygon", { id: 'inner6', style: {
                    animation: 'iui-blink 1s -1s infinite',
                }, fill: '#62bb47', points: '370 213.62 370 427.23 462.5 373.83 554.99 320.43 370.05 213.65 370 213.62' }),
            React.createElement("polygon", { id: 'outer7', style: {
                    animation: 'iui-blink 1s -0.39s infinite',
                }, fill: '#62bb47', points: '185.01 320.42 185.01 534.03 92.51 480.63 0.02 427.23 184.96 320.45 185.01 320.42' }),
            React.createElement("polygon", { id: 'inner2', style: {
                    animation: 'iui-blink 1s -0.33s infinite',
                }, fill: '#62bb47', points: '185.01 320.42 185.01 534.03 277.51 480.63 370 427.23 185.06 320.45 185.01 320.42' }),
            React.createElement("polygon", { id: 'inner3', style: {
                    animation: 'iui-blink 1s -0.5s infinite',
                }, fill: '#62bb47', points: '370 427.21 370 640.83 277.5 587.42 185.01 534.02 369.95 427.25 370 427.21' }),
            React.createElement("polygon", { id: 'inner4', style: {
                    animation: 'iui-blink 1s -0.67s infinite',
                }, fill: '#62bb47', points: '370 427.21 370 640.83 462.5 587.42 554.99 534.02 370.05 427.25 370 427.21' }),
            React.createElement("polygon", { id: 'outer9', style: {
                    animation: 'iui-blink 1s -0.5s infinite',
                }, fill: '#62bb47', points: '185 534.01 185 747.63 92.5 694.23 0.01 640.83 184.95 534.04 185 534.01' }),
            React.createElement("polygon", { id: 'outer10', style: {
                    animation: 'iui-blink 1s -0.56s infinite',
                }, fill: '#62bb47', points: '185 534.01 185 747.63 277.5 694.23 369.99 640.83 185.05 534.04 185 534.01' }),
            React.createElement("polygon", { id: 'outer13', style: {
                    animation: 'iui-blink 1s -0.72s infinite',
                }, fill: '#62bb47', points: '555 534.01 555 747.63 462.5 694.23 370.01 640.83 554.95 534.04 555 534.01' }),
            React.createElement("polygon", { id: 'outer14', style: {
                    animation: 'iui-blink 1s -0.78s infinite',
                }, fill: '#62bb47', points: '555 534.01 555 747.63 647.5 694.23 739.99 640.83 555.05 534.04 555 534.01' }),
            React.createElement("polygon", { id: 'outer11', style: {
                    animation: 'iui-blink 1s -0.61s infinite',
                }, fill: '#62bb47', points: '370 640.82 370 854.42 277.5 801.02 185.01 747.63 369.95 640.85 370 640.82' }),
            React.createElement("polygon", { id: 'outer12', style: {
                    animation: 'iui-blink 1s -0.67s infinite',
                }, fill: '#62bb47', points: '370 640.82 370 854.42 462.5 801.02 554.99 747.63 370.05 640.85 370 640.82' }),
            React.createElement("polygon", { id: 'inner5', style: {
                    animation: 'iui-blink 1s -0.83s infinite',
                }, fill: '#62bb47', points: '555 320.42 555 534.03 462.5 480.63 370.01 427.23 554.95 320.45 555 320.42' }),
            React.createElement("polygon", { id: 'outer16', style: {
                    animation: 'iui-blink 1s -0.89s infinite',
                }, fill: '#62bb47', points: '555 320.42 555 534.03 647.5 480.63 739.99 427.23 555.05 320.45 555 320.42' }),
            React.createElement("polygon", { id: 'outer17', style: {
                    animation: 'iui-blink 1s -0.94s infinite',
                }, fill: '#62bb47', points: '740 213.62 740 427.23 647.5 373.83 555.01 320.43 739.95 213.65 740 213.62' }),
            React.createElement("polygon", { id: 'outer15', style: {
                    animation: 'iui-blink 1s -0.83s infinite',
                }, fill: '#62bb47', points: '740 427.21 740 640.83 647.5 587.42 555.01 534.02 739.95 427.25 740 427.21' }),
            React.createElement("polygon", { id: 'outer-1', style: {
                    animation: 'iui-blink 1s -0.05s infinite',
                }, fill: '#62bb47', points: '555 106.81 555 320.42 462.5 267.02 370.01 213.62 554.95 106.84 555 106.81' }),
            React.createElement("polygon", { id: 'outer18', style: {
                    animation: 'iui-blink 1s -1s infinite',
                }, fill: '#62bb47', points: '555 106.81 555 320.42 647.5 267.02 739.99 213.62 555.05 106.84 555 106.81' }),
            React.createElement("path", { id: 'iModel', fill: '#fff', d: 'M370,131.93a59.58,59.58,0,1,1-59.58,59.57A59.58,59.58,0,0,1,370,131.93ZM538.21,647.2a14,14,0,0,1-6.84,12l-152.8,91a14,14,0,0,1-14.29,0l-155.6-91.88a14,14,0,0,1-6.89-12.07V565.52a14,14,0,0,1,14-14,13.84,13.84,0,0,1,7.16,2l91,50.38V411.52l-49.22-31.36a14,14,0,0,1-6.85-12.05V287a14,14,0,0,1,21.21-12l140.18,77.56a14,14,0,0,1,6.82,12V603.86l91-50.38a13.84,13.84,0,0,1,7.16-2,14,14,0,0,1,14,14Z' }))));
}
export default SvgIModelLoader;
